import { FC, ReactElement } from 'react'
import logo from './logo.svg'
import styled from 'styled-components'
import Link from 'components/Link'
import colorVariables from '../../Globals/colors.module.scss'
import fontVariables from '../../Globals/fonts.module.scss'

const MainComponent: FC<MicroFrontendProps> = ({ tenant, colorMode }): ReactElement => {
  return (
    <AppContainer className={ colorVariables.globalColors + " " + fontVariables.globalFonts } >
      <header className='App-header'>
        <img src={logo} className='App-logo' alt='logo' />
        <p>
        Im on tenant: <b className='tenant'> {tenant?.name}  📰 </b>
        </p>
        <p>
          My current mood is:{' '}
          <b>
            {colorMode} {colorMode === 'dark' ? '🌚' : (colorMode === 'light' ? '☀️' : '?')}
          </b>
        </p>
        <Link url='https://reactjs.org' />
      </header>
    </AppContainer>
  )
}
const AppContainer = styled.div<{tenant?: string}>`
  width: 100%;
  margin: 0;
  padding: 0;
  font-family: var(--font-plex);
  color: var(--brandblue-main);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }
  .App-logo {
    height: 40vmin;
    pointer-events: none;
  }

  @media (prefers-reduced-motion: no-preference) {
    .App-logo {
      animation: App-logo-spin infinite 20s linear;
    }
  }

  .App-header {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 3rem;
    .tenant{
     ${props =>  props.tenant ? `color: var(--tenant-${props.tenant})` : ''}
    }
  }

  @keyframes App-logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`
export default MainComponent
